const StorageItem = require('../storage-page/storage-item-view')

module.exports = StorageItem.extend({
  template: require('./bar-item.pug').default
})
